export default __webpack_public_path__ + "static/charLeft-b13573f8c4976b9444be842b146bda7a.png";